import { __assign, __awaiter, __generator } from "tslib";
import { UTMCookie } from '../storage/utm-cookie';
import { getQueryParams } from '../utils/query-params';
import { UTM_CAMPAIGN, UTM_CONTENT, UTM_MEDIUM, UTM_SOURCE, UTM_TERM, UTMZ_SOURCE, UTMZ_MEDIUM, UTMZ_CAMPAIGN, UTMZ_TERM, UTMZ_CONTENT, GCLID, FBCLID, BASE_CAMPAIGN, } from './constants';
var CampaignParser = /** @class */ (function () {
    function CampaignParser() {
        this.utmCookieStorage = new UTMCookie();
    }
    CampaignParser.prototype.parse = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = [__assign({}, BASE_CAMPAIGN)];
                        return [4 /*yield*/, this.getUtmParam()];
                    case 1: return [2 /*return*/, __assign.apply(void 0, [__assign.apply(void 0, [__assign.apply(void 0, _a.concat([(_b.sent())])), this.getReferrer()]), this.getClickIds()])];
                }
            });
        });
    };
    CampaignParser.prototype.getUtmParam = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, cookies, _a, utmSource, utmMedium, utmCampaign, utmTerm, utmContent;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        params = getQueryParams();
                        return [4 /*yield*/, this.utmCookieStorage.isEnabled()];
                    case 1:
                        _a = (_b.sent());
                        if (!_a) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.utmCookieStorage.get('__utmz')];
                    case 2:
                        _a = (_b.sent());
                        _b.label = 3;
                    case 3:
                        cookies = (_a) || {};
                        utmSource = params[UTM_SOURCE] || cookies[UTMZ_SOURCE];
                        utmMedium = params[UTM_MEDIUM] || cookies[UTMZ_MEDIUM];
                        utmCampaign = params[UTM_CAMPAIGN] || cookies[UTMZ_CAMPAIGN];
                        utmTerm = params[UTM_TERM] || cookies[UTMZ_TERM];
                        utmContent = params[UTM_CONTENT] || cookies[UTMZ_CONTENT];
                        return [2 /*return*/, {
                                utm_source: utmSource,
                                utm_medium: utmMedium,
                                utm_campaign: utmCampaign,
                                utm_term: utmTerm,
                                utm_content: utmContent,
                            }];
                }
            });
        });
    };
    CampaignParser.prototype.getReferrer = function () {
        var _a, _b;
        var data = {
            referrer: undefined,
            referring_domain: undefined,
        };
        try {
            data.referrer = document.referrer || undefined;
            data.referring_domain = (_b = (_a = data.referrer) === null || _a === void 0 ? void 0 : _a.split('/')[2]) !== null && _b !== void 0 ? _b : undefined;
        }
        catch (_c) {
            // nothing to track
        }
        return data;
    };
    CampaignParser.prototype.getClickIds = function () {
        var _a;
        var params = getQueryParams();
        return _a = {},
            _a[GCLID] = params[GCLID],
            _a[FBCLID] = params[FBCLID],
            _a;
    };
    return CampaignParser;
}());
export { CampaignParser };
//# sourceMappingURL=campaign-parser.js.map